import { createComponent } from '@carvana/merch-components';

export const PaginationButton = createComponent('li', {
  className:
    'flex h-36 w-36 items-center justify-center rounded-full border border-solid border-grey-2 hover:border-blue-6'
});

export const PaginationNumber = createComponent('li', {
  className: 'flex h-36 w-36 items-center justify-center rounded-full'
});
